/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';

const IconYoutube = () => (
  <svg version="1.1" id="youtube" xmlns="http://www.w3.org/2000/svg" height="22" width="22" viewBox="0 0 192 192" xmlSpace="preserve">
    <path style={{ fill: '#A0A0A0' }} d="M180.3,53.4c-2-7.6-8-13.6-15.6-15.7C151,34,96,34,96,34s-55,0-68.8,3.7c-7.6,2.1-13.5,8-15.6,15.7C8,67.2,8,96,8,96s0,28.8,3.7,42.6c2,7.6,8,13.6,15.6,15.7C41,158,96,158,96,158s55,0,68.8-3.7c7.6-2.1,13.5-8,15.6-15.7C184,124.8,184,96,184,96S184,67.2,180.3,53.4z M78,122.2V69.8L124,96L78,122.2z" />
  </svg>
);
IconYoutube.propTypes = {};

export default IconYoutube;
